<ek-dialog-header>
  <div class="dialog-header">
    <span>{{ 'INSEGNAMENTO.LEGEND_MODAL.HEADER' | translate }}</span>
    <ek-button (click)="close()" [ekStyle]="'text'" [icon]="'close'"></ek-button>
  </div>
</ek-dialog-header>

<ek-dialog-body>
  <div class="legend-container" *ngIf="selectedItem$ | async as item">
    <span class="legend-section-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.INSEGNAMENTO' | translate }}</span>

    <div class="legend-item">
      <div class="legend-content">
        <span class="legend-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.ATTIVITA' | translate }}</span>
        <span class="legend-description">{{ item.insegnamento }}</span>
      </div>
    </div>
    <ek-divider></ek-divider>

    <div class="legend-item">
      <div class="legend-content">
        <span class="legend-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.DOCENTE' | translate }}</span>
        <span class="legend-description">{{ item.docente }}</span>
      </div>
    </div>
    <ek-divider></ek-divider>

    <div class="legend-item">
      <div class="legend-content">
        <span class="legend-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.CDS' | translate }}</span>
        <span class="legend-description">{{ item.cds }}</span>
      </div>
    </div>
    <ek-divider></ek-divider>

    <div class="legend-item">
      <div class="legend-content">
        <span class="legend-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.SEDE' | translate }}</span>
        <span class="legend-description">{{ item.sede }}</span>
      </div>
    </div>
    <ek-divider></ek-divider>

    <span class="legend-section-second-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.CORSO' | translate }}</span>

    <div class="legend-item">
      <div class="legend-content">
        <span class="legend-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.CORSO_LAUREA' | translate }}</span>
        <span class="legend-description">{{ item.tipoCorso }}</span>
      </div>
    </div>
    <ek-divider></ek-divider>

    <div class="legend-item">
      <div class="legend-content">
        <span class="legend-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.TIPO_CORSO' | translate }}</span>
        <span class="legend-description">{{ item.tipoCorso }}</span>
      </div>
    </div>
    <ek-divider></ek-divider>

    <div class="legend-item">
      <div class="legend-content">
        <span class="legend-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.CLASSE_LAUREA' | translate }}</span>
        <span class="legend-description">{{ item.classeLaurea }}</span>
      </div>
    </div>
    <ek-divider></ek-divider>

    <div class="legend-item">
      <div class="legend-content">
        <span class="legend-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.SEDE' | translate }}</span>
        <span class="legend-description">{{ item.sede }}</span>
      </div>
    </div>
    <ek-divider></ek-divider>

    <div class="legend-item">
      <div class="legend-content">
        <span class="legend-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.COORTE' | translate }}</span>
        <span class="legend-description">{{ item.coorte }}</span>
      </div>
    </div>
    <ek-divider></ek-divider>

    <div class="legend-item">
      <div class="legend-content">
        <span class="legend-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.INDIRIZZO' | translate }}</span>
        <span class="legend-description">{{ item.indirizzo }}</span>
      </div>
    </div>
    <ek-divider></ek-divider>

    <div class="legend-item">
      <div class="legend-content">
        <span class="legend-title">{{ 'INSEGNAMENTO.LEGEND_MODAL.DIPARTIMENTO' | translate }}</span>
        <span class="legend-description">{{ item.dipartimento }}</span>
      </div>
    </div>
    <ek-divider></ek-divider>

  </div>
</ek-dialog-body>

<ek-dialog-footer>
  <div class="dialog-footer">
    <ek-button [ekStyle]="'filled'" [icon]="'topic'" (click)="openChangeModal()" [label]="'INSEGNAMENTO.LEGEND_MODAL.INSEGNAMENTO' | translate" *ngIf="canOpenChangeModal$ | async"></ek-button>
  </div>
</ek-dialog-footer>